import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Errors, ManagerService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { CreatePromotionService } from 'src/app/core/services/create-promotion.service';
import { CONSTANTS } from 'src/app/config';

@Component({
  selector: 'app-activity-tab',
  templateUrl: './activity-tab.component.html',
})
export class ActivityTabComponent implements OnInit, OnChanges {
  @Input() isCiscoAdmin: boolean = false;
  @Input() isAdminUser: boolean = false;
  @Input() isPracticeLead: boolean = false;
  @Input() isSalesManager: boolean = false;
  @Input() pviEligible: boolean = false;
  @Input() userProfile: any = null;
  @Input() currentTab: string = 'activity';

  @Output() navigateToPromotions = new EventEmitter<void>();

  errors: Errors = { errors: {} };

  showChallengeList: boolean | null = false;
  allChallengeTypes: any;
  challengeType = 'Bookings Challenge';
  challengeData: any;
  editChallengeData: any = null;

  dataSource: any = { content: [], totalElements: 0 };
  salesChallengePage = 1;
  pageNo = 0;
  pageSize = 5;
  salesChallengeLoading = false;
  budgetCapGrid = false;
  catogoriesLIst: any;
  countryGroupList: any;

  allChallengesPage = 1;
  searchText = '';
  size = 4;
  sortBy: any;
  selectedChallengeId: any;
  selectedChallengeCreatedOn: any;

  conformModalOpen = false;
  pendingConfirmAction: (() => void) | null = null;
  descriptionModalOpen = false;

  submitForApprovalModalOpen = false;
  submitForApprovalRow: any = null;
  finalizeChallenge: any = null;
  dfTrigger: any = null;
  approvalTrackerChallenge: any = null;
  cloneChallengeModalOpen = false;
  pendingCloneElement: any = null;

  errMessages = CONSTANTS.validationMessages.manageActivity;

  constructor(
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
    private promotionService: CreatePromotionService,
  ) {}

  ngOnInit() {
    const lang = localStorage.getItem('selectedLanguage');
    if (lang === 'Korean') {
      this.errMessages = CONSTANTS.validationMessages.korean_manageActivity;
    } else if (lang === 'Japanese') {
      this.errMessages = CONSTANTS.validationMessages.japanese_manageActivity;
    }
    this.getAllChallengeTypes();
    this.getCountryGroupList();
    this.setInitialView();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isCiscoAdmin'] && !changes['isCiscoAdmin'].firstChange) {
      this.getAllChallengeTypes();
      this.setInitialView();
    }
    if (changes['currentTab'] && !changes['currentTab'].firstChange) {
      if (this.currentTab === 'activity') {
        this.editChallengeData = null;
        this.showChallengeList = (this.isCiscoAdmin || this.isSalesManager || this.isPracticeLead || this.isAdminUser) ? true : false;
      } else if (this.currentTab === 'sales' && this.isCiscoAdmin) {
        this.showChallengeList = null;
        this.getViewChallengeData();
      }
    }
  }

  private setInitialView() {
    if (this.userProfile && this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM') {
      this.showChallengeList = true;
      return;
    }
    if (this.isCiscoAdmin && this.currentTab === 'sales') {
      this.showChallengeList = null;
      this.getViewChallengeData();
    } else if (this.isCiscoAdmin || this.isSalesManager || this.isPracticeLead || this.isAdminUser) {
      this.showChallengeList = true;
    } else {
      this.showChallengeList = false;
    }
  }

  getAllChallengeTypes() {
    const lang = localStorage.getItem('selectedLanguage');
    this.managerService.getAllChallengeTypes(this.isCiscoAdmin).subscribe(
      (data: any) => {
        this.allChallengeTypes = data.reduce((activeChallenges: any, item: any) => {
          activeChallenges.push({ id: item.id, name: item.name, shortName: item.shortName.toLowerCase() });
          return activeChallenges;
        }, []);
        if (lang === 'Korean' || lang === 'Japanese') {
          Object.keys(this.allChallengeTypes).forEach((key) => {
            if (this.allChallengeTypes[key]['name'] === 'Bookings Challenge') {
              this.allChallengeTypes[key]['name'] = lang === 'Korean' ? '부킹 챌린지' : 'ブッキングチャレンジ';
            }
            if (this.allChallengeTypes[key]['name'] === 'Architecture Challenge') {
              this.allChallengeTypes[key]['name'] = lang === 'Korean' ? '아키텍처 챌린지' : 'アーキテクチャチャレンジ';
            }
            if (this.allChallengeTypes[key]['name'] === 'Training Challenge') {
              this.allChallengeTypes[key]['name'] = lang === 'Korean' ? '트레이닝 챌린지' : 'トレーニングチャレンジ';
            }
          });
        }
      },
      (err: any) => { this.errors = err; }
    );
  }

  getViewChallengeData(pageNo?: any, element?: any) {
    if (pageNo != undefined) {
      this.pageNo = pageNo.pageIndex;
      this.pageSize = pageNo.pageSize;
    }
    const params = this.userProfile.id + '?page=' + this.pageNo + '&size=' + this.pageSize;
    this.salesChallengeLoading = true;
    this.managerService.getViewChallengeData(params).subscribe(
      (data: any) => {
        if (element) { element.showSpinner = false; }
        this.dataSource = data.pagableCreatorsViewChallenges;
        this.catogoriesLIst = data.fileUploadCategories;
        this.salesChallengeLoading = false;
      },
      (err: any) => {
        this.errors = err;
        this.salesChallengeLoading = false;
      }
    );
  }

  getCountryGroupList() {
    this.managerService.getCountryGroupList().subscribe(
      (data: any) => {
        const groupedByRegion: any = {};
        for (const item of data) {
          if (!groupedByRegion[item.region]) { groupedByRegion[item.region] = []; }
          groupedByRegion[item.region].push(item);
        }
        this.countryGroupList = groupedByRegion;
      },
      (err: any) => { this.errors = err; }
    );
  }

  showOrHideCreateActivityLayout() {
    this.showChallengeList = !this.showChallengeList;
    if (!this.isCiscoAdmin) {
      this.editChallengeData = null;
      if (this.showChallengeList === false) {
        // credits fetched by LeaderCreateChallengeComponent
      } else {
        this.allChallengesPage = 1;
        this.searchText = '';
      }
    } else {
      this.editChallengeData = null;
      this.challengeData = null;
      this.challengeType = 'Bookings Challenge';
    }
  }

  editChallenge(challenge: any) {
    if (!this.isCiscoAdmin) {
      this.getPendingData(challenge);
    } else {
      this.challengeData = challenge;
      this.challengeType = challenge.type.name;
      this.editChallengeData = challenge;
      this.showChallengeList = false;
    }
  }

  getPendingData(challenge: any) {
    const param = { challengeId: challenge.id };
    this.managerService.getChallengesParticipants(param).subscribe(
      (data: any) => {
        if (data) {
          challenge.users = data.users;
          challenge.courses = data.courses;
          challenge.type.shortName = challenge.type.shortName.toLowerCase();
          this.selectedChallengeId = challenge.id;
          this.selectedChallengeCreatedOn = challenge.createdOn;
          this.showChallengeList = false;
          this.editChallengeData = { ...challenge };
        }
      },
      (err: any) => { this.errors = err; }
    );
  }

  submitStatus(event: any) {
    if (event) {
      this.editChallengeData = null;
      this.showChallengeList = true;
    }
  }

  onSalesChallengePageChange(page: number) {
    this.salesChallengePage = page;
    this.getViewChallengeData({ pageIndex: page - 1, pageSize: this.pageSize });
  }

  EditChallenge(val: any) {
    this.promotionService.setCiscoAdminData(val);
    this.navigateToPromotions.emit();
  }

  copyChallengeContent(element: any) {
    this.pendingCloneElement = element;
    this.cloneChallengeModalOpen = true;
  }

  onCloneChallengeConfirm() {
    this.cloneChallengeModalOpen = false;
    this.promotionService.setCiscoAdminData({ ...this.pendingCloneElement, copy: true });
    this.pendingCloneElement = null;
    this.navigateToPromotions.emit();
  }

  closeCloneChallengeModal() {
    this.cloneChallengeModalOpen = false;
    this.pendingCloneElement = null;
  }

  onToggleLayoutFromList() {
    this.promotionService.setCiscoAdminData(null);
    this.navigateToPromotions.emit();
  }

  showBudgetCap() { this.budgetCapGrid = true; }
  hideBudgetCap() { this.budgetCapGrid = false; }

  submitForApproval(val: any) {
    this.submitForApprovalRow = val;
    this.submitForApprovalModalOpen = true;
  }

  closeSubmitForApprovalModal() {
    this.submitForApprovalModalOpen = false;
    this.submitForApprovalRow = null;
  }

  confirmSubmitForApproval() {
    const val = this.submitForApprovalRow;
    val.showSpinner = true;
    this.submitForApprovalModalOpen = false;
    this.submitForApprovalRow = null;
    const params: any = 'id=' + val.id + '&status=PENDING_APPROVAL';
    this.managerService.submitForApproval(params).subscribe((data: any) => {
      if (data !== '') {
        this.popupMessageService.showSuccess('Approval mail sent successfully', 'success');
        this.getViewChallengeData(null, val);
      }
    });
  }

  finalizeChllenge(data: any) {
    this.finalizeChallenge = {
      challengeData: data,
      categories: this.catogoriesLIst,
      countryGroupList: this.countryGroupList,
    };
  }

  onFinalizeChallengeClosed() {
    this.finalizeChallenge = null;
    this.getViewChallengeData();
  }

  downloadFilePopup(data: any, mode: 'fileDownload' | 'uploadDocument') {
    if (data == null) { return; }
    this.dfTrigger = { data, mode, categories: this.catogoriesLIst, countryGroupList: this.countryGroupList };
  }

  onDfModalClosed() {
    this.dfTrigger = null;
    this.getViewChallengeData();
  }

  approvalTrackerPopup(val: any) { this.approvalTrackerChallenge = val; }

  onApprovalTrackerClosed() {
    this.approvalTrackerChallenge = null;
    this.getViewChallengeData();
  }

  openDescription() { this.descriptionModalOpen = true; }
  closeDescriptionModal() { this.descriptionModalOpen = false; }

  closeConformModal() {
    this.conformModalOpen = false;
    this.pendingConfirmAction = null;
  }

  onConformConfirm() {
    this.conformModalOpen = false;
    if (this.pendingConfirmAction) {
      const action = this.pendingConfirmAction;
      this.pendingConfirmAction = null;
      action();
    }
  }

  onLeaderSubmitBooking(event: { formValue: any, updateFlag: boolean, selectedChallengeType: any }) {
    this.pendingConfirmAction = () => this.executePostBookingChallenge(event.formValue, event.updateFlag, event.selectedChallengeType);
    this.conformModalOpen = true;
  }

  onLeaderSubmitArchitecture(event: { formValue: any, updateFlag: boolean, selectedChallengeType: any }) {
    this.pendingConfirmAction = () => this.executePostArchitectureChallenge(event.formValue, event.updateFlag, event.selectedChallengeType);
    this.conformModalOpen = true;
  }

  onLeaderSubmitTraining(event: { formValue: any, updateFlag: boolean, selectedChallengeType: any, selectedLearningMapsCourses: any[] }) {
    this.pendingConfirmAction = () => this.executePostEnablementChallenge(
      event.formValue, event.updateFlag, event.selectedChallengeType, event.selectedLearningMapsCourses
    );
    this.conformModalOpen = true;
  }

  executePostBookingChallenge(formValue: any, updateFlag: boolean, selectedChallengeType: any) {
    const lang = localStorage.getItem('selectedLanguage');
    const postChallengeType: any = Object.assign({}, formValue);
    postChallengeType['managerId'] = this.userProfile.id;
    postChallengeType.completeBy = new Date(postChallengeType.completeBy).toISOString();
    postChallengeType.startDate = new Date(postChallengeType.startDate).toISOString();
    postChallengeType.userIds = postChallengeType.users.map((item: any) => item.id);
    delete postChallengeType.users;

    const challengeType = selectedChallengeType;
    postChallengeType.typeId = challengeType.id;
    postChallengeType.acronym = '';
    postChallengeType.beGeoIds = [this.userProfile.company.beGeoId];
    postChallengeType.category = 'ASSIGNED_ACTIVITY';
    postChallengeType.description = '';
    postChallengeType.regions = [this.userProfile.company.region];
    postChallengeType.typeName = '';
    postChallengeType.roleIds = [];
    postChallengeType.challengeRewards = '';
    postChallengeType.creatorType = 'LEADER';

    if (!updateFlag) {
      this.managerService.createBookingChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Bookings Challenge created successfully.';
          if (lang === 'Korean') { msg = '부킹 챌린지가 성공적으로 생성되었습니다.'; }
          if (lang === 'Japanese') { msg = 'ブッキングチャレンジを作成しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    } else {
      postChallengeType['id'] = this.selectedChallengeId;
      postChallengeType['createdOn'] = this.selectedChallengeCreatedOn;
      this.managerService.updateBookingChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Bookings Challenge updated successfully.';
          if (lang === 'Korean') { msg = '부킹 챌린지가 성공적으로 업데이트되었습니다.'; }
          if (lang === 'Japanese') { msg = 'ブッキングチャレンジを更新しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    }
  }

  executePostArchitectureChallenge(formValue: any, updateFlag: boolean, selectedChallengeType: any) {
    const lang = localStorage.getItem('selectedLanguage');
    const postChallengeType: any = Object.assign({}, formValue);
    postChallengeType['managerId'] = this.userProfile.id;
    postChallengeType.completeBy = new Date(postChallengeType.completeBy).toISOString();
    postChallengeType.startDate = new Date(postChallengeType.startDate).toISOString();
    postChallengeType.userIds = postChallengeType.users.map((item: any) => item.id);
    const challengeType = selectedChallengeType;
    postChallengeType.typeId = challengeType.id;
    delete postChallengeType.users;

    const archTypeAndAmountGroup = postChallengeType.archTypeAndAmountGroup;
    postChallengeType['architectureTargets'] = archTypeAndAmountGroup.map((group: any, index: number) => ({
      architectureTypeIds: group.architectureTypeId,
      architectureBookingsToBeSold: Number(group.architectureBookingsToBeSold),
      sortOrder: index,
    }));
    delete postChallengeType.archTypeAndAmountGroup;
    postChallengeType.acronym = '';
    postChallengeType.beGeoIds = [this.userProfile.company.beGeoId];
    postChallengeType.category = 'ASSIGNED_ACTIVITY';
    postChallengeType.description = '';
    postChallengeType.regions = [this.userProfile.company.region];
    postChallengeType.typeName = '';
    postChallengeType.roleIds = [];
    postChallengeType.challengeRewards = '';
    postChallengeType.creatorType = 'LEADER';

    if (!updateFlag) {
      this.managerService.createArchitectureChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Architecture Challenge created successfully.';
          if (lang === 'Korean') { msg = '아키텍처 챌린지가 성공적으로 생성되었습니다.'; }
          if (lang === 'Japanese') { msg = 'アーキテクチャチャレンジを作成しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    } else {
      postChallengeType['id'] = this.selectedChallengeId;
      postChallengeType['createdOn'] = this.selectedChallengeCreatedOn;
      this.managerService.updateArchitectureChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Architecture Challenge updated successfully.';
          if (lang === 'Korean') { msg = '아키텍처 챌린지가 성공적으로 업데이트되었습니다.'; }
          if (lang === 'Japanese') { msg = 'アーキテクチャチャレンジを更新しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    }
  }

  executePostEnablementChallenge(formValue: any, updateFlag: boolean, selectedChallengeType: any, selectedLearningMapsCourses: any[]) {
    const lang = localStorage.getItem('selectedLanguage');
    const postChallengeType: any = Object.assign({}, formValue);
    postChallengeType['managerId'] = this.userProfile.id;
    postChallengeType.completeBy = new Date(postChallengeType.completeBy).toISOString();
    postChallengeType.startDate = new Date(postChallengeType.startDate).toISOString();
    postChallengeType.userIds = postChallengeType.users.map((item: any) => item.id);
    postChallengeType['challengeType'] = selectedChallengeType;
    delete postChallengeType.users;

    const courseIds = selectedLearningMapsCourses
      .filter((item: any) => item.id.includes('-c'))
      .map((item: any) => ({ courseId: item.id.replace('-c', '') }));
    const learningMapIds = selectedLearningMapsCourses
      .filter((item: any) => item.id.includes('-m'))
      .map((item: any) => ({ learningMapId: item.id.replace('-m', '') }));
    postChallengeType['courseIdsDTOS'] = courseIds;
    postChallengeType['learningMapIdsDTOS'] = learningMapIds;

    if (!updateFlag) {
      this.managerService.createTrainingChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Training Challenge created successfully.';
          if (lang === 'Korean') { msg = '트레이닝 챌린지가 성공적으로 생성되었습니다.'; }
          if (lang === 'Japanese') { msg = 'トレーニングチャレンジを作成しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    } else {
      postChallengeType['id'] = this.selectedChallengeId;
      postChallengeType['createdOn'] = this.selectedChallengeCreatedOn;
      this.managerService.updateTrainingChallenge(postChallengeType).subscribe(
        (data: any) => {
          let msg = 'Training Challenge updated successfully.';
          if (lang === 'Korean') { msg = '트레이닝 챌린지가 성공적으로 업데이트되었습니다.'; }
          if (lang === 'Japanese') { msg = 'トレーニングチャレンジを更新しました。'; }
          this.popupMessageService.showSuccess(msg, 'success');
          this.editChallengeData = null;
          this.showChallengeList = true;
        },
        (err: any) => { this.errors = err; }
      );
    }
  }
}
